"use strict";
/* eslint-disable local-rules/disallow-side-effects */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = exports.useRoutes = exports.createMemoryRouter = exports.createHashRouter = exports.createBrowserRouter = void 0;
const react_router_dom_1 = require("react-router-dom");
const reactRouter_1 = require("../domain/reactRouter");
exports.createBrowserRouter = (0, reactRouter_1.wrapCreateRouter)(react_router_dom_1.createBrowserRouter);
exports.createHashRouter = (0, reactRouter_1.wrapCreateRouter)(react_router_dom_1.createHashRouter);
exports.createMemoryRouter = (0, reactRouter_1.wrapCreateRouter)(react_router_dom_1.createMemoryRouter);
exports.useRoutes = (0, reactRouter_1.wrapUseRoutes)({
    useRoutes: react_router_dom_1.useRoutes,
    useLocation: react_router_dom_1.useLocation,
    matchRoutes: react_router_dom_1.matchRoutes,
});
exports.Routes = (0, reactRouter_1.createRoutesComponent)(exports.useRoutes, react_router_dom_1.createRoutesFromChildren);
//# sourceMappingURL=reactRouter.js.map